import { useState } from "react"
import { Button, Grid, InputAdornment, TextField, Typography, useMediaQuery, useTheme } from "@mui/material"
import { usePlan } from "../../../Plans"
import { useInitReq } from "../../../InitReq"
import { useTranslation } from "../../../i18n"
import requests from "../../../api/client"
import { ISettingsItem } from "../../../Settings"

export default function Coupon({ name, variables }: ISettingsItem) {
  const [couponError, setCouponError] = useState<boolean>(false)
  const { virtualChip, currentPlan } = usePlan()
  const { t } = useTranslation()
  const theme = useTheme()
  const isMd = useMediaQuery(theme.breakpoints.between('md', 'lg'))
  const { couponText: coupon, couponValid, couponValue, couponPercent, updateInitState } = useInitReq()
  const defaultTextArray = [
    t.page2.coupon.title,
    t.page2.coupon.remove,
    t.page2.coupon.active,
    t.page2.coupon.codeLabel,
    !isMd ? t.page2.coupon.activateLong : t.page2.coupon.activate,
  ]
  const { text = defaultTextArray } = variables || {}
  const couponValueFormatted = Math.floor(couponValue)
  const discountText = couponPercent ? `${couponValueFormatted}%` : `-R$ ${couponValueFormatted},00`

  const handleCoupon = async () => {
    if (coupon === '') {
      setCouponError(true)
      return
    }

    const requestData = {
      cupom: coupon,
      plano: currentPlan.id,
      operacao: virtualChip ? "A" : "L"
    }

    const resultado = await requests.couponValidator(requestData)
    const valido = resultado.ok && Boolean(resultado.data?.valido)

    if (valido) {
      updateInitState({
        couponValid: true,
        couponValue: resultado.data.valor,
        couponPercent: resultado.data.tipo === 'PERCENTUAL'
      })
    } else {
      updateInitState({ couponValid: false, couponValue: 0 })
    }

    setCouponError(!valido)
  }

  return (
    <Grid container item className={name ? `${name} coupon` : "coupon"} xs={12}>
      <Typography variant="h3" dangerouslySetInnerHTML={{ __html: text[0] }} />
      {couponValid ? (
        <Grid container item sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Grid item>
            <Grid item sx={{ display: 'flex', gap: 1 }}>
              <Typography className="currentCoupon" dangerouslySetInnerHTML={{ __html: coupon }} />
              <Typography
                className="removeCouponBtn"
                dangerouslySetInnerHTML={{ __html: text[1] }}
                onClick={() => updateInitState({ couponValid: false, couponValue: 0, couponText: '' })}
              />
            </Grid>
            <Typography dangerouslySetInnerHTML={{ __html: text[2] }} />
          </Grid>
          <Grid item>
            <Typography variant="h3" dangerouslySetInnerHTML={{ __html: discountText }} />
          </Grid>
        </Grid>
      ) : (
        <TextField
          error={couponError}
          helperText={couponError ? t.errors.invalidCoupon : ''}
          name="coupon"
          value={coupon}
          onChange={(e) => {setCouponError(false); updateInitState({ couponValue: 0, couponText: e.target.value })}}
          fullWidth
          label={text[3]}
          type="text"
          size="small"
          sx={(theme) => ({
            [theme.breakpoints.only('md')]: {
              transform: 'scale(0.7)',
              transformOrigin: 'left center',
              marginTop: '-2px'
            }
          })}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Button onClick={handleCoupon} size="small" sx={{ textTransform: 'none' }}>
                  {text[4]}
                </Button>
              </InputAdornment>
            )
          }}
        />
      )}
    </Grid>
  )
}